<template>
  <div class="my-container add-new">
    <el-drawer :visible.sync="view.addNew.show" direction="btt" size="12%" :show-close="false" custom-class="add-new">
      <el-col :span="5">
        <div @click="openAiPaint()">
          <i class="iconfont my-aigc" />
          <div>{{ $t('i.start_aigc') }}</div>
        </div>
      </el-col>
      <el-col :span="5">
        <div @click="openVoxel()">
          <i class="iconfont my-vox" />
          <div>{{ $t('i.type_vox') }}</div>
        </div>
      </el-col>
      <el-col :span="5">
        <div @click="openEditer">
          <i class="iconfont my-gridsfy" />
          <div>{{ $t('i.pixelArt') }}</div>
        </div>
      </el-col>
      <el-col :span="5">
        <div @click="openPopPage('toBrickfy')">
          <i class="iconfont my-avatar" />
          <div>{{ $t('i.aiPixelPuzzle') }}</div>
        </div>
      </el-col>
      <el-col :span="5">
        <div @click="openPost">
          <i class="iconfont my-post-add" />
          <div>{{ $t('i.addPost') }}</div>
        </div>
      </el-col>
      <!-- <el-col :span="6">
        <el-dropdown trigger="click" placement="top" @command="(cmd) =>emit('openMyPublish', [cmd])">
          <div>
            <i class="iconfont my-plus" />
            <div class="color-ff">{{ $t('i.publish') }}...</div>
          </div>
          <el-dropdown-menu slot="dropdown" class="my-dropdown">
            <el-dropdown-item v-for="(workClass, idx) in workClasses" v-show="workClass.quick_add" :key="idx" :command="workClass.type" :icon="workClass.icon" class="iconfont" :class="{ 'bg-blue': workClass.checked }">{{ workClass.label }}</el-dropdown-item>
            <el-dropdown-item command="post" icon="iconfont my-post-add">{{ $t('i.addPost') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col> -->
      <!-- <el-col :span="6">
        <div @click="openPost">
          <i class="iconfont my-post-add" />
          <div>{{ $t('i.addPost') }}</div>
        </div>
      </el-col>
      <el-col :span="6">
        <div @click="openPopPage('toBrickfy')">
          <i class="iconfont my-avatar" />
          <div>{{ $t('i.aiPixelPuzzle') }}</div>
        </div>
      </el-col> -->
      <!-- <el-col :span="7">
        <div @click="openPopPage('toBeadsPixel')">
          <i class="iconfont my-bean" />
          <div>{{ $t('i.aiBeadsPixel') }}</div>
        </div>
      </el-col> -->
      <!-- <el-col :span="4">
        <div @click="openPopPage('toCartoon')">
          <i class="iconfont my-cartoon" />
          <div>{{ $t('i.aiCartoon') }}</div>
        </div>
      </el-col>
      <el-col :span="4">
        <div @click="openAiPaint">
          <i class="iconfont my-ai-paint" />
          <div>{{ $t('i.aiart') }}</div>
        </div>
      </el-col> -->
    </el-drawer>
  </div>
</template>
<script>
import { mixins } from '@/mixins/common'
import conf from '@/js/conf/conf'
export default {
  components: {},
  mixins: [mixins],
  data() {
    const data = {
      workClasses: conf.workClasses()
    }
    return data
  },
  methods: {
    handle(act, data) {
      this.emit(act, data)
    },
    openPopPage(type) {
      this.view.addNew.show = false
      this.emit('openPopPage', [{ 'type': type }])
    },
    openPost() {
      this.view.addNew.show = false
      this.emit('openPost')
    },
    openVoxel() {
      this.view.addNew.show = false
      this.emit('openVoxel')
    },
    openEditer() {
      this.view.addNew.show = false
      // this.view.createNewfile = true
      this.goto('editer', [])
    },
    openAiPaint() {
      this.view.addNew.show = false
      this.goto('aiart', [])
    }
  }
}
</script>
